import React from 'react';
import PropTypes from 'prop-types';
import cn from 'src/classnames';
import styles from '../NextLink/NextLink.module.scss';
import { addProtocolIfNeed } from '../../utils/common';

const OuterLink = ({ href, children, className, disabled, rel, startIcon, type, title }) => {
  const linkTitle = title || (typeof children === 'string' ? children : null);
  return (
    <a
      href={addProtocolIfNeed(href)}
      className={cn(styles.link, className, {
        [styles.disabled]: disabled,
        [styles.textType]: type === 'text',
        [styles.iconLink]: Boolean(startIcon),
      })}
      target="_blank"
      rel={rel}
      title={linkTitle}
    >
      {startIcon && <span className={styles.iconBox}>{startIcon}</span>}
      {children}
    </a>
  );
};

OuterLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  startIcon: PropTypes.element,
  type: PropTypes.oneOf(['text', 'link']),
  title: PropTypes.string,
};

OuterLink.defaultProps = {
  disabled: false,
  rel: 'nofollow',
  type: 'link',
};

export default OuterLink;
